/**
 * UCP Service - централизованные вызовы для UCP (User Control Panel)
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const ucpService = {
    getUserCharacters: async () => {
        return apiClient.post(ENDPOINTS.UCP.GET_CHARACTERS, {}, true, true);
    },

    checkAdmin: async () => {
        // ACP check-admin endpoint
        return apiClient.post(ENDPOINTS.ACP.CHECK_ADMIN, {}, true, true);
    },

    deleteCharacter: async (characterId) => {
        return apiClient.delete(ENDPOINTS.UCP.DELETE_CHARACTER, {
            character_id: characterId,
        });
    },

    getRoleSituations: async () => {
        return apiClient.post(
            ENDPOINTS.UCP.GET_ROLE_SITUATIONS,
            {},
            true,
            true,
        );
    },

    createCharacter: async (characterData) => {
        // Use user data in body as the legacy client expects
        return apiClient.put(
            ENDPOINTS.UCP.CREATE_CHARACTER,
            characterData,
            true,
            true,
        );
    },

    getUserInfo: async () => {
        return apiClient.post(ENDPOINTS.UCP.GET_USER_INFO, {}, true, true);
    },

    disableGoogleTwoAuth: async () => {
        return apiClient.delete(ENDPOINTS.TWO_FACTOR.DISABLE_TWO_AUTH, {});
    },

    newSecretKey: async () => {
        return apiClient.post(
            ENDPOINTS.TWO_FACTOR.NEW_SECRET_KEY,
            {},
            true,
            true,
        );
    },

    changeUserPassword: async (newPassHash) => {
        return apiClient.post(
            ENDPOINTS.UCP.CHANGE_USER_PASSWORD,
            { new_password: newPassHash },
            true,
            true,
        );
    },

    getCharacterInfo: async (characterId) => {
        return apiClient.post(
            ENDPOINTS.UCP.GET_CHARACTER_INFO,
            { character_id: characterId },
            true,
            true,
        );
    },

    getNotifications: async (characterId = null) => {
        const payload = characterId ? { character_id: characterId } : {};
        return apiClient.post(
            ENDPOINTS.UCP.GET_NOTIFICATIONS,
            payload,
            true,
            true,
        );
    },

    getRoleSituation: async (situationId) => {
        return apiClient.post(
            ENDPOINTS.UCP.GET_ROLE_SITUATION,
            { situation_id: situationId },
            true,
            true,
        );
    },

    /* Shop / Favorites */
    getShopItems: async () => {
        return apiClient.get(ENDPOINTS.UCP.GET_SHOP_ITEMS, {}, true);
    },

    getFavouriteItems: async () => {
        return apiClient.get(
            ENDPOINTS.UCP.GET_FAVOURITE_ITEMS,
            {
                user_id: localStorage.getItem("user-id"),
                user_name: localStorage.getItem("user-login"),
                user_password: localStorage.getItem("user-password"),
            },
            true,
        );
    },

    putInFavourites: async (itemId) => {
        return apiClient.post(
            ENDPOINTS.UCP.PUT_IN_FAVOURITES,
            { item_id: itemId },
            true,
            true,
        );
    },

    deleteFromFavourites: async (itemId) => {
        return apiClient.put(
            ENDPOINTS.UCP.DELETE_FROM_FAVOURITES,
            { item_id: itemId },
            true,
            true,
        );
    },

    getShopItem: async (itemId) => {
        return apiClient.get(
            ENDPOINTS.UCP.GET_SHOP_ITEM,
            { item_id: itemId },
            true,
        );
    },

    getShopItemStats: async (itemId) => {
        return apiClient.get(
            ENDPOINTS.UCP.GET_SHOP_ITEM_STATS,
            { item_id: itemId },
            true,
        );
    },

    buyItem: async (targetCharacter, itemId) => {
        return apiClient.put(
            ENDPOINTS.UCP.BUY_ITEM,
            { target_character: targetCharacter, item_id: itemId },
            true,
            true,
        );
    },
};

export default ucpService;
